import React from "react";
import "../style/critical-care.css";
import Servicessidebar from "../components/servicessidebar";

const CriticalCare = () => {
    const highlights1 = [
        "MICU",
        "Qualified & Trained Intensivists",
        "Multidisciplinary Team Approach",
        "ACLS/BLS Trained Staff"
    ];

    const highlights2 = [
        "ATLS (Advanced Trauma Life Support) and ACLS (Advanced Cardiac Life Support) Triage area equipped with world-class emergency facilities",
        "Mobile Emergency unit with a Defibrillator, Multi Para Monitor and Ventilator"
    ];

    const traumaTeam = [
        "Trauma Surgeons",
        "Trained Nursing Staff",
        "Support Technicians"
    ];

    const CriticalCare = ({ items }) => (
        <ul className="cc-list">
            {items.map((item, i) => (
                <li key={i} className="cc-item">
                    <span className="cc-icon">➤</span>
                    {item}
                </li>
            ))}
        </ul>
    );

    return (
        <div className="cc-wrapper">
            <div className="container">
                <div className="critical-care-je">
                    <div className="cc-left">

                        <h2 className="cc-title">CRITICAL CARE</h2>
                        <p className="cc-text">
                            The prompt and proper management of a critically ill patient is one of the challenges facing modern society.
                            Committed to addressing this need, SAL’s Critical Care department offers 75 medical and surgical ICU beds
                            equipped with essential armamentarium, including Ventilator and BiPAP support for Ventilatory failure.
                            Our advanced speciality ICUs cater to every acute emergency, including Cardiac, Medical, Surgical and Trauma Patients.
                        </p>

                        <h3 className="cc-subtitle">ECMO–ECLS System – A Breath of Life</h3>
                        <p className="cc-text">
                            The SAL Critical Care Department is empowered by the life-saving ECMO ECLS (Extracorporeal Membrane Oxygenation –
                            Extracorporeal Life Support) System. ECMO is a ray of hope for such patients whose lungs can no longer oxygenate
                            and the heart cannot perfuse the oxygen despite maximum efforts, which can result in multi-organ failure and loss of life.
                        </p>

                        <h4 className="cc-highlight-title">Highlights</h4>
                        <CriticalCare items={highlights1} />

                        <h3 className="cc-subtitle">Guarding the Patient in the Golden Hour</h3>
                        <p className="cc-text">
                            Our highly responsive trauma centre ensures every trauma patient is treated within 60 minutes
                            (Golden Hour) of the incidence.
                        </p>

                        <h4 className="cc-highlight-title">Highlights</h4>
                        <CriticalCare items={highlights2} />

                        <h3 className="cc-subtitle">24×7 Emergency Trauma Team</h3>
                        <CriticalCare items={traumaTeam} />
                    </div>

                    <div className="cc-right">
                        <Servicessidebar />
                    </div>
                </div>
            </div>
        </div>
    );
};

export default CriticalCare;
